// removed by extract-text-webpack-plugin
module.exports = {"openVersionColor":"#7EBD00","terminatedVersionColor":"#FC5A4F","closedVersionColor":"#FFC62C","draftVersionColor":"#C8C8CC","delayNodeColor":"#E8E889","eventListenerNodeColor":"#FFC27F","messageNodeFillColor":"#7FDDD7","entryEventHeaderCircleColor":"#E4E6EB","iconFillColor":"#3F404A"};


//////////////////
// WEBPACK FOOTER
// ./src/components/stylesheets/PushNodeModal.scss
// module id = 594
// module chunks = 0